module.exports = __webpack_public_path__ + "media/img/pages/companies/siegfried-6a693ea0eeab3bdcfcc70907dea8d8b0.jpg";